import Text, { type Variant } from "./Text";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import styles from "./CountBadge.module.css";

interface CountBadgeProps {
  count: number | string;
  variant?: Variant;
  className?: string;
}

export default function CountBadge({
  count,
  variant = "deci",
  className,
}: CountBadgeProps) {
  return (
    <Text
      as="span"
      variant={variant}
      weight="bold"
      color="white"
      className={classnames(styles.badge, className)}
    >
      {count}
    </Text>
  );
}
